import qs from "qs";
import React, { useEffect, useState } from "react";
import SearchBox from "../../common/searchBox";
import Table from "../../common/table";
import { useGetHelpQueries, useGetHelpTopics } from "../../../queryHooks";
import getBadgeClasses from "../../../util/badgeClass";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import { ROLES_CONFIG } from "../../../config/configs";
import CS from "../../../services/commonService";
//	Pre-defined values
const columnKey = "userHelpQueries";
const options = [
	{ value: "OPEN", label: "Open" },
	{ value: "RESOLVED", label: "Resolved" },
];
//	Component starts
const HelpQueries = ({ userId, tabChangeCounter }) => {
	//	State values
	const [helpTopics, setHelpTopics] = useState([]);
	const [tableData, setTableData] = useState();
	const [pageNow, setPageNow] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [helpQueriesPayload, setHelpQueriesPayload] = useState({
		pagination: true,
		items_per_page: itemsPerPage,
		page: pageNow,
		filter: {
			["help_queries.user_id"]: userId,
		},
		sort: { "help_queries.created_at": "DESC" },
		is_restaurant: 0,
	});

	const { data: dataGetHelpQueries, isLoading } = useGetHelpQueries(
		qs.stringify(helpQueriesPayload)
	);

	useEffect(() => {
		if (dataGetHelpQueries && dataGetHelpQueries.status === "success") {
			let respData = dataGetHelpQueries.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [dataGetHelpQueries]);

	const { data: dataGetHelpTopic } = useGetHelpTopics(
		qs.stringify({
			pagination: false,
			filter: { ["help_topics.role_id"]: ROLES_CONFIG.USER },
		})
	);

	useEffect(() => {
		if (dataGetHelpTopic && dataGetHelpTopic.data?.records) {
			let _helpTopics = [];
			dataGetHelpTopic.data.records.forEach((element) => {
				_helpTopics.push({
					label: element.name,
					value: element.id,
				});
			});
			setHelpTopics(_helpTopics);
		}
	}, [dataGetHelpTopic]);

	useEffect(() => {
		setPageNow(1);
		setItemsPerPage(10);
		setHelpQueriesPayload({
			pagination: true,
			items_per_page: 10,
			page: 1,
			filter: {
				["help_queries.user_id"]: userId,
			},
			is_restaurant: 0,
		});
	}, [userId]);

	useEffect(() => {
		setHelpQueriesPayload({
			...helpQueriesPayload,
			filter: {
				["help_queries.user_id"]: userId,
			},
			is_restaurant: 0,
		});
	}, [tabChangeCounter]);

	const columns = [
		{
			label: "Query",
			type: "string",
			sort: true,
			path: "topic_name",
			alias: "help_topics.name",
			aliasFilter: "help_topics.id",
			filterOptions: helpTopics,
		},
		{
			label: "Message",
			type: "string",
			sort: true,
			path: "description",
			alias: "help_queries.description",
		},
		{
			label: "Created On",
			type: "date",
			sort: true,
			path: "created_at",
			alias: "help_queries.created_at",
			filterDate: true,
			content: (item) => getCurrentTimezoneDate(item.created_at),
		},
		{
			label: "Status",
			type: "boolean",
			path: "status",
			// sort: true,
			// alias: "help_queries.status",
			aliasFilter: "help_queries.status",
			filterOptions: options,
			content: (item) => (
				<p className={getBadgeClasses(item.status)}>{item.status}</p>
			),
		},
		{
			label: "Closed Date",
			type: "string",
			sort: true,
			path: "resolved_at",
			alias: "help_queries.resolved_at",
			filterDate: true,
			content: (item) =>
				item.status !== "OPEN"
					? item.resolved_at && getCurrentTimezoneDate(item.resolved_at)
					: "--",
		},
	];

	return (
		<>
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												search={(value) => {
													setPageNow(1);
													setHelpQueriesPayload({
														...helpQueriesPayload,
														search: {
															"help_topics.name":
																!value && value === "" ? undefined : value,
															"help_queries.description":
																!value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>
								</div>
							</div>
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								sortCol={(obj) => {
									setPageNow(1);
									setHelpQueriesPayload({
										...helpQueriesPayload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setHelpQueriesPayload({ ...helpQueriesPayload, page });
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setHelpQueriesPayload({
										...helpQueriesPayload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(
											helpQueriesPayload.filter,
											obj
										);
										setPageNow(1);
										setHelpQueriesPayload({
											...helpQueriesPayload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setHelpQueriesPayload({
											...helpQueriesPayload,
											filter: {
												...helpQueriesPayload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setHelpQueriesPayload({
										...helpQueriesPayload,
										filter_date: dates && {
											...helpQueriesPayload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
								tabChangeCounter={tabChangeCounter}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default HelpQueries;
